import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NeoComunService } from '../../../comun/services/neoComun.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { AlertService } from '../../../services/alert.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { Constantes } from 'src/app/comun/data/constantes';

declare var $: any;

const datosDetalleSolicitud = {
  idSolicitud: '',
  usuario: null,
};
const datosAceptarSolicitud = {
  idCliente: null,
  idUsuario: null,
  idSolicitud: '',
  observaciones: '',
};
@Component({
    selector: 'app-aprobar-oferta-if',
    templateUrl: './aprobar-oferta-if.component.html',
    styleUrls: ['./aprobar-oferta-if.component.scss'],
    providers: [NeoComunService, NeoIntermediarioFinancieroService],
    standalone: false
})
export class AprobarOfertaIfComponent implements OnInit {
  public detalleSolcitud: any;
  public user;
  auxCaracteres: any = 0;
	aprobarForm: UntypedFormGroup;
	idTrazabilidad: number = 0;
	isTransaccional: boolean = false;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    private _userIntermediarioService: UserService,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _router: RouterService,
	private _sweetAlert: SweetAlertService,
	private _fb: UntypedFormBuilder,
	private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.aprobarForm = this._fb.group({
      observacionAprobar: ['', [Validators.required, Validators.maxLength(1500)]]
    });
    const nav = this.router.getCurrentNavigation();
    this.isTransaccional = nav?.extras.state?.['from'] === Constantes.TRANSACCIONAL;
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      datosDetalleSolicitud.idSolicitud = params['id'];
      datosDetalleSolicitud.usuario = Number(this.user.idUsuario);
    });
    datosAceptarSolicitud.idCliente = Number(this.user.idCliente);
    datosAceptarSolicitud.idSolicitud = datosDetalleSolicitud.idSolicitud;
    datosAceptarSolicitud.idUsuario = Number(this.user.idUsuario);
    this.aprobacionOferta();
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
    this._router.goBack();
  }

  aprobar() {
    if (this.aprobarForm.get('observacionAprobar').value != '') {
      if (this.aprobarForm.valid) {
        datosAceptarSolicitud.observaciones = this.aprobarForm.get('observacionAprobar').value;
        this._neoIntermediarioFinancieroService
          .aceptarSolicitud(datosAceptarSolicitud)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this.cerrarTrazabilidad(this.idTrazabilidad);
                this._sweetAlert.successModal('¡Éxito!',
                  false,
                  'La oferta ha sido aprobada correctamente').then(
                    (result) => {
                      if (result.isConfirmed) {
                        this.router.navigate(['/intermediario/home']);
                      }
                    }
                  );
              } else {
                this._sweetAlert.errorModal("Error!", true, 'No fue posible aprobar la solicitud');
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible aprobar la solicitud');
            }
          );
      } else {
        this.aprobarForm.markAllAsTouched();
        this._sweetAlert.errorModal("Error!", true, 'Excedes los 1500 caracteres máximos permitidos para la observación.');
      }
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Ingrese la observación');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }

  validarLongitud() {
    this.auxCaracteres = this.aprobarForm.get('observacionAprobar').value.length;
  }

  validateField(key: string) {
    return (
      (this.aprobarForm.get(key).dirty ||
        this.aprobarForm.get(key)?.touched) &&
      this.aprobarForm.get(key)?.invalid
    );
  }
  // Trazabilidad

  aprobacionOferta() {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
      nombrePantalla: Constantes.APROBAR_OFERTA,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(datosAceptarSolicitud.idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarAprobacionOferta(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });

  }

  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}